import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { adminGetPosts, adminDeletePost } from '../api/api';
import './AdminPosts.css';

const AdminPosts = () => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const { user, loading: authLoading, logoutUser } = useAuth();
  const navigate = useNavigate();

useEffect(() => {
  if (!authLoading && !user) {
    navigate('/admin/login');
    return;
  }
  if (user) {
    fetchPosts();
  }
  // eslint-disable-next-line
}, [user, authLoading, page]);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const data = await adminGetPosts({ page, size: 20 });
      setPosts(data.posts || []);
      setTotalPages(data.totalPages || 0);
    } catch (err) {
      console.error('Failed to fetch posts:', err);
      if (err.response?.status === 401 || err.response?.status === 403) {
        logoutUser();
        navigate('/admin/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, title) => {
    if (!window.confirm(`"${title}" gönderisini silmek istiyor musun?`)) return;
    try {
      await adminDeletePost(id);
      fetchPosts();
    } catch (err) {
      alert('Silme işlemi başarısız oldu.');
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('tr-TR');
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <div className="admin-header-left">
          <Link to="/" className="admin-back">← siteye dön</Link>
          <h1>gönderi yönetimi</h1>
        </div>
        <div className="admin-header-right">
          <span className="admin-user">{user?.username}</span>
          <button onClick={logoutUser} className="admin-logout-btn">çıkış</button>
          <Link to="/admin/posts/new" className="admin-new-btn">+ yeni gönderi</Link>
        </div>
      </div>

      {loading ? (
        <div className="admin-loading">yükleniyor...</div>
      ) : posts.length === 0 ? (
        <div className="admin-empty">
          <p>henüz gönderi yok.</p>
          <Link to="/admin/posts/new" className="admin-new-btn">ilk gönderiyi oluştur</Link>
        </div>
      ) : (
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>başlık</th>
                <th>kategori</th>
                <th>tarih</th>
                <th>etiketler</th>
                <th>işlemler</th>
              </tr>
            </thead>
            <tbody>
              {posts.map(post => (
                <tr key={post.id}>
                  <td className="admin-post-title">
                    <Link to={`/post/${post.slug}`} target="_blank">{post.title}</Link>
                  </td>
                  <td>
                    <span className="admin-category">{post.category?.toLowerCase()}</span>
                  </td>
                  <td className="admin-date">{formatDate(post.publishedDate)}</td>
                  <td className="admin-tags-cell">
                    {post.tags?.map(tag => (
                      <span key={tag} className="admin-tag">{tag}</span>
                    ))}
                  </td>
                  <td className="admin-actions">
                    <Link to={`/admin/posts/edit/${post.id}`} className="admin-edit-btn">düzenle</Link>
                    <button onClick={() => handleDelete(post.id, post.title)} className="admin-delete-btn">sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <div className="admin-pagination">
          <button disabled={page === 0} onClick={() => setPage(p => p - 1)}>← önceki</button>
          <span>{page + 1} / {totalPages}</span>
          <button disabled={page >= totalPages - 1} onClick={() => setPage(p => p + 1)}>sonraki →</button>
        </div>
      )}
    </div>
  );
};

export default AdminPosts;
